import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: "What's included in the VIP Plan?",
  answer: 'The plan includes 2 professional cleanings, 2 regular exams, 1 set of X-rays, 1 emergency exam, an oral cancer screening, full mouth digital scan, intraoral photos, plus 20% off all other dental treatments.'
}, {
  question: 'Is this dental insurance?',
  answer: 'No, the VIP Plan is not dental insurance. It is an in-house membership savings plan designed to provide affordable, predictable dental care directly to our patients without the hassle of deductibles, waiting periods, or claims.'
}, {
  question: 'Can I use the VIP Plan for my family?',
  answer: 'Absolutely! The VIP Plan is perfect for families. Plus, you receive a 10% discount on membership fees for each additional family member you enroll.'
}, {
  question: 'Can I pay monthly instead of annually?',
  answer: 'Yes, we offer a flexible monthly payment option of $50/month for those who prefer to spread out the cost of their membership.'
}, {
  question: 'What treatments get the 20% discount?',
  answer: 'The 20% discount applies to virtually all other dental treatments offered at Lima Dental Group, including fillings, crowns, root canals, and cosmetic procedures. Ask our team for specific details.'
}, {
  question: 'How do I get started?',
  answer: 'Getting started is easy! Simply fill out the form on this page, and our friendly team will contact you to finalize your enrollment and schedule your first visit.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 lg:py-32 bg-brand-darker" data-id="element-75">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="text-center mb-8 lg:mb-16" data-id="element-77">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-2xl md:text-4xl lg:text-5xl font-light text-white mb-3 lg:mb-6 tracking-tight" data-id="element-78">
            Frequently Asked Questions
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1,
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-base lg:text-lg text-brand-muted font-light" data-id="element-79">
            Everything you need to know about the Lima Dental VIP Plan.
          </motion.p>
        </div>

        <div className="space-y-3 lg:space-y-4" data-id="element-80">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-brand-card border border-brand-border rounded-xl lg:rounded-2xl overflow-hidden" data-id="element-81">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 lg:px-8 py-4 lg:py-6 text-left flex justify-between items-center focus:outline-none" data-id="element-82">
                <span className="font-light text-base lg:text-lg text-white pr-6 lg:pr-8" data-id="element-83">
                  {faq.question}
                </span>
                <div className="flex-shrink-0 text-white/50" data-id="element-84">
                  {openIndex === index ? <Minus className="w-5 h-5" strokeWidth={1.5} data-id="element-85" /> : <Plus className="w-5 h-5" strokeWidth={1.5} data-id="element-86" />}
                </div>
              </button>

              <AnimatePresence data-id="element-87">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-88">
                    <div className="px-5 lg:px-8 pb-5 lg:pb-8 text-brand-muted font-light leading-relaxed text-sm lg:text-base" data-id="element-89">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}